import React from 'react';
import PropTypes from 'prop-types';
import {GlassTubeTooltip} from './GlassTubeTooltip';
import {useGlassTube} from './GlassTube.utils';
import className from './style.module.scss';

const DROPPED_ID = 'DROPPED_ID';

export function GlassTube(props) {
  const {drawGlassTube} = useGlassTube();

  const [showControls, setShowControls] = React.useState(false);

  const toggleShowControls = (value) => () => setShowControls(value);

  const onDragOver = (event) => event.preventDefault();

  const onDrop = (event) => {
    const droppedID = event.dataTransfer.getData(DROPPED_ID);
    if (droppedID) {
      props.onDropItem(parseInt(droppedID));
    }
  };

  return (
    <div
      tabIndex='0'
      onDrop={onDrop}
      onDragOver={onDragOver}
      onMouseEnter={toggleShowControls(true)}
      onMouseLeave={toggleShowControls(false)}
      className={`${className.glassTube} ${props.className}`}>
      <GlassTubeTooltip
        boxId={props.boxId}
        snailId={props.snailId}
        plantId={props.plantId}
        solution={props.solution}
        showControls={showControls}
        stopperId={props.stopperId}
        onRemoveItem={props.onRemoveItem}
      />
      <div className={className.glassTube_image}>{drawGlassTube(props)}</div>
    </div>
  );
}

GlassTube.propTypes = {
  /**
   * Color value for the solution [ Empty means no solution]
   */
  solution: PropTypes.string,
  /**
   * UniqueId for the stopper covering the tube
   */
  stopperId: PropTypes.number,
  /**
   * UniqueId for the plant dropped in tube
   */
  plantId: PropTypes.number,
  /**
   * UniqueId for the snail dropped in tube
   */
  snailId: PropTypes.number,
  /**
   * UniqueId of the box covering the solution
   */
  boxId: PropTypes.number,
  /**
   * Label to be displayed on the tube
   */
  tubeLabel: PropTypes.string,
  /**
   * Invoked when an Item is dropped in or over glasstube
   */
  onDropItem: PropTypes.func,
  /**
   * Invoked when an item dropped in/over glasstube is removed
   */
  onRemoveItem: PropTypes.func,
};

GlassTube.defaultProps = {
  className: 'glassTube',
  stopperId: undefined,
  solution: '',
  plantId: undefined,
  snailId: undefined,
  boxId: undefined,
  tubeLabel: '',
};
